import clsx from 'clsx';
import styles from './SHRMMessage.module.css';

type MessageProps = {
  color: string;
  text: string;
  showMessage: boolean;
};

const SHRMMessage = (props: MessageProps) => {
  return (
    <>
      <div
        style={{ backgroundColor: props.color }}
        className={clsx(
          styles.message,
          props.showMessage === true ? styles.fadeIn : styles.fadeOut
        )}
      >
        {props.text}
      </div>
    </>
  );
};

export default SHRMMessage;
